export default __webpack_public_path__ + "static/media/photo--lg--misc-20.cf4ff139.jpg";